// extracted by mini-css-extract-plugin
export default {"custom-element-preview-container":"Fs6OTv","customElementPreviewContainer":"Fs6OTv","premium-banner":"BS0QhD","premiumBanner":"BS0QhD"};